import React, { createContext, useCallback, useState } from "react";

interface MapsContextType {
  newLat: number;
  newLng: number;
  setNewLatLng: (newLat: number, newLng: number) => void;
}

interface MapsContextProviderProps {
  children: React.ReactNode;
}

const MapsContext = createContext<MapsContextType>({
  newLat: 0,
  newLng: 0,
  setNewLatLng: () => {},
});

const MapsContextProvider: React.FC<MapsContextProviderProps> = ({
  children,
}) => {
  const [newLat, setNewLat] = useState(0);
  const [newLng, setNewLng] = useState(0);

  const setNewLatLng = useCallback(
    (newLat: number, newLng: number) => {
      setNewLat(newLat);
      setNewLng(newLng);
    },
    [setNewLat, setNewLng]
  );

  return (
    <MapsContext.Provider value={{ newLat, newLng, setNewLatLng }}>
      {children}
    </MapsContext.Provider>
  );
};

export { MapsContext, MapsContextProvider };
